import { render, staticRenderFns } from "./CertificateSurviveDialog.vue?vue&type=template&id=32d9d2da&scoped=true"
import script from "./CertificateSurviveDialog.vue?vue&type=script&lang=js"
export * from "./CertificateSurviveDialog.vue?vue&type=script&lang=js"
import style0 from "./CertificateSurviveDialog.vue?vue&type=style&index=0&id=32d9d2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9d2da",
  null
  
)

export default component.exports